// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".privacy__table[data-v-05613e96]{color:#fff;word-wrap:break-word;white-space:pre-line;font-size:16px;line-height:22px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
